import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';

const TablaHistorial = ({ rowData }) => {
    const [trips, setTrips] = useState([]);

    useEffect(() => {
        const fetchTripsData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_DRIVERs_ID}/${rowData.driver_id}`,
                    {
                        headers: {
                            "x-hasura-admin-secret": process.env.REACT_APP_API_KEY,
                        },
                    }
                );
                setTrips(response.data.trips);
            } catch (error) {
                console.error("Error fetching trips data:", error);
            }
        };
        fetchTripsData();
    }, [rowData]);

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    };

    const columns = [
        {
            name: 'ID de Viaje',
            selector: row => row.viajeId,
            sortable: true,
        },
        {
            name: 'ID Cliente',
            selector: row => row.clienteId,
            sortable: true,
        },
        {
            name: 'Nombre Cliente',
            selector: row => {
                if (row.user) {
                    return `${row.user.name ?? 'N/A'} ${row.user.last_name ?? 'N/A'}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: true,
        },
        {
            name: 'Fecha',
            selector: row => formatDate(row.fechaSolicitud),
            sortable: true,
        },
        {
            name: 'Cobro',
            selector: row => ("$" + row.total),
            sortable: true,
        },
    ];


    const paginationComponentOptions = {
        rowsPerPageText: "Filas por página",
        rangeSeparatorText: "de",
        selectAllRowsItem: true,
        selectAllRowsItemText: "Todos",
    };

    return (
        <div className='rounded-tl-2xl rounded-tr-2xl mx-auto'>
            <DataTable
                columns={columns}
                data={trips}
                noDataComponent={<div className="text-center mt-5 mb-5">No hay registros para mostrar.</div>}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                paginationComponentOptions={paginationComponentOptions}
                customStyles={{
                    rows: {
                        style: {
                            borderTop: '1px solid #CBD5E0',
                        },
                    },
                    headCells: {
                        style: {
                            fontSize: '1.25rem',
                            textAlign: 'center',
                        },
                    },
                    cells: {
                        style: {
                            marginTop: '1rem',
                            marginBottom: '1rem',
                            fontSize: '1rem',
                        },
                    },
                    pagination: {
                        style: {
                            fontSize: '1rem',
                            borderBottomLeftRadius: '2rem',
                            borderBottomRightRadius: '2rem',
                            color: 'black',
                        },
                    },
                }}
            />
        </div>
    );

};

export default TablaHistorial;
